import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { StatsAiOverviewDTO } from '@solverml/api';

import {
  StatsAiDashboardComponent,
  StatsAiDashboardSection
} from '../stats-ai-dashboard/stats-ai-dashboard.component';

type ComparisonBlock = {
  title: string;
  section: StatsAiDashboardSection;
};

@Component({
  selector: 'app-stats-ai-dashboard-comparison',
  standalone: true,
  imports: [
    CommonModule,
    StatsAiDashboardComponent
  ],
  templateUrl: './stats-ai-dashboard-comparison.component.html',
  styleUrls: ['./stats-ai-dashboard-comparison.component.scss']
})
export class StatsAiDashboardComparisonComponent {
  @Input({ required: true }) teamStats!: StatsAiOverviewDTO;
  @Input({ required: true }) opponentStats!: StatsAiOverviewDTO;
  @Input({ required: true }) teamLabel!: string;
  @Input({ required: true }) opponentLabel!: string;

  public readonly kpiSections: StatsAiDashboardSection[] = ['kpis'];

  public readonly compactBlocks: ComparisonBlock[] = [
    { title: 'Desglose de Lanzamientos', section: 'throwTypeBreakdown' },
    { title: 'Eficacia de Lanzamientos', section: 'throwTypeEfficiency' },
    { title: 'Rendimiento por Modelo de Juego', section: 'modelPerformance' },
    { title: 'Rendimiento contra Defensas Rivales', section: 'defensePerformance' },
    { title: 'Rendimiento contra Ataques Rivales', section: 'opponentAttackPerformance' },
    { title: 'Desglose de Lanzamientos Rivales', section: 'opponentThrowBreakdown' }
  ];

  public readonly largeBlocks: ComparisonBlock[] = [
    { title: 'Tipos de Lanzamiento por Minuto', section: 'throwTypeByTime' },
    { title: 'Evolución de Goles por Tramo', section: 'goalsByTime' },
    { title: 'Eficacia de Paradas por Minutos', section: 'savesByTime' }
  ];

  public get teamScore(): number | null {
    return this.getGoalsTotal(this.teamStats, 'goals_for');
  }

  public get opponentScore(): number | null {
    return this.getGoalsTotal(this.teamStats, 'goals_against');
  }

  public get hasScore(): boolean {
    return this.teamScore !== null && this.opponentScore !== null;
  }

  private getGoalsTotal(
    stats: StatsAiOverviewDTO,
    field: 'goals_for' | 'goals_against'
  ): number | null {
    const intervals = stats?.goals_by_time_interval || [];
    if (!intervals.length) {
      return null;
    }
    return intervals.reduce((acc, item) => acc + Number(item[field] || 0), 0);
  }
}
